import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/lib/auth";
import AppLayout from "@/layouts/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import GeneratePix from "@/pages/GeneratePix";
import Transactions from "@/pages/Transactions";
import Withdraw from "@/pages/Withdraw";
import Settings from "@/pages/Settings";
import Disputes from "@/pages/Disputes";
import ThankYou from "@/pages/ThankYou";
import { Loader2 } from "lucide-react";

function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/obrigado" element={<ThankYou />} />
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/gerar-pix" element={<GeneratePix />} />
              <Route path="/vendas" element={<Transactions />} />
              <Route path="/contestacoes" element={<Disputes />} />
              <Route path="/saque" element={<Withdraw />} />
              <Route path="/configuracoes" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "hsl(240 6% 10%)",
                color: "hsl(0 0% 98%)",
                border: "1px solid hsl(240 4% 16%)",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
